import { getStroke, getSvgPathFromStroke } from '@uiw/react-signature';
import { SIGNATURE_PEN_SIZE } from './signatureQuality';

// Default options from @uiw/react-signature — must match exactly so stored SVG
// looks identical to what the canvas renders via perfect-freehand.
export const PERFECT_FREEHAND_OPTIONS = {
    size: SIGNATURE_PEN_SIZE,
    smoothing: 0.46,
    thinning: 0.73,
    streamline: 0.5,
    easing: (t: number) => t,
    start: { taper: 0, easing: (t: number) => t, cap: true },
    end: { taper: 0, easing: (t: number) => t, cap: true },
};

/**
 * Convert raw strokes (number[][][]) to an SVG path string using the same
 * perfect-freehand rendering that the canvas uses. Produces smooth bezier
 * filled paths identical to what the guest drew on screen.
 */
export const strokesToSvg = (strokes: number[][][]): string => {
    if (!strokes || strokes.length === 0) return '';
    return strokes
        .filter(s => s && s.length > 0)
        .map(stroke => getSvgPathFromStroke(getStroke(stroke, PERFECT_FREEHAND_OPTIONS)))
        .join('');
};
